/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig';
import { DynamoDbBillingMode } from '../models/DynamoDbBillingMode';

/**
* Configuration for restoring to DynamoDB.
*/
export class AwsDynamoDBDestination {
  /**
  * Region to restore to.
  */
  'restoreRegion': string;
  /**
  * ID of the key you want Eon to use for encrypting the restored resource.
  */
  'encryptionKeyId': string;
  /**
  * Name to assign to the restored resource.
  */
  'restoredName': string;
  /**
  * Write capacity units for the restored table. Defaults to 5. 
  */
  'writeCapacityUnits'?: number;
  'restoreBillingMode'?: DynamoDbBillingMode;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };
  'advancedIndexConfig'?: DynamoDBAdvancedIndexConfig;
  /**
  * Dev mode toggle: if true, runs the full restore flow up to the actual import and returns there. Used for debugging. Default: false. 
  */
  'skipActualImport'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreRegion",
      "baseName": "restoreRegion",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoredName",
      "baseName": "restoredName",
      "type": "string",
      "format": ""
    },
    {
      "name": "writeCapacityUnits",
      "baseName": "writeCapacityUnits",
      "type": "number",
      "format": ""
    },
    {
      "name": "restoreBillingMode",
      "baseName": "restoreBillingMode",
      "type": "DynamoDbBillingMode",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "advancedIndexConfig",
      "baseName": "advancedIndexConfig",
      "type": "DynamoDBAdvancedIndexConfig",
      "format": ""
    },
    {
      "name": "skipActualImport",
      "baseName": "skipActualImport",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDBDestination.attributeTypeMap;
  }

  public constructor() {
  }
}



